import { render, staticRenderFns } from "./point_creator.vue?vue&type=template&id=5e1f6289&"
import script from "./point_creator.vue?vue&type=script&lang=js&"
export * from "./point_creator.vue?vue&type=script&lang=js&"
import style0 from "./point_creator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports